export const IssuanceUploadGridConfig = {
	list: 'Issuance',
	grid: {
		gridId:'IssuanceUploadGrid',
		checkbox: false,
		edit: false,
		delete: true,
		height: 500,
		pageSize: 10,
		groupable: false
	},
	columns: {
        Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		IssuanceKey: {
			dataName: 'IssuanceKey',
			type: 'string',
			title: 'IssuanceKey',
			width: 100,
			hidden: true
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false
		},
		ProgramProgramID: {
			class:'value',
			dataName: 'ProgramProgramID',
			type: 'string',
			title: 'Program ID',
			width: 100,
			hidden: false
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'ProgramTitle',
			type: 'string',
			title: 'Program',
			width: 150,
			hidden: false,
			readOnly:true
		},
		ProgramAlias: {
			class: 'lookup',
			dataName: 'ProgramAlias',
			type: 'string',
			title: 'Project',
			width: 150,
			hidden: true,
			readOnly:true
		},
		ReceiverReceiverID: {
			class:'value',
			dataName: 'ReceiverReceiverID',
			type: 'string',
			title: 'Partner ID',
			width: 100,
			hidden: false,
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'ReceiverFullName',
			type: 'string',
			title: 'Partner',
			width: 150,
			hidden: false,
			readOnly:true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 100,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 120,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 100,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 100,
			hidden: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: false
        },
        BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'BusinessEvent',
			width: 100,
			hidden: true
		},
    }
}